export function bindSitePagePartialClick(element: HTMLElement): void {
  if (element.dataset.sitePagePartialClickable === '1') {
    return;
  }

  const link = element.querySelector('.site-page-partial__link') as HTMLAnchorElement | null;
  if (!link) {
    return;
  }

  element.dataset.sitePagePartialClickable = '1';
  element.addEventListener('click', () => {
    const href = link.getAttribute('href');
    if (href) {
      window.location.href = href;
    }
  });
}

export const useSitePagePartial = () => {
  const list: NodeListOf<HTMLElement> = document.querySelectorAll('.site-page-partial__content');

  if (list.length > 0) {
    list.forEach(bindSitePagePartialClick);
  }
};

useSitePagePartial();
